export default __webpack_public_path__ + "static/media/manicure.0538c19c.jpg";